import { EmptyList } from 'components/core/empty-list/EmptyList'

export { EmptyList }
